import React from 'react';
import PageSEO from "@/components/common/PageSEO";
import Spacing from "@/components/common/Spacing";
import './legal-pages.css';

const PoliticaCookies: React.FC = () => {
  return (
	<>
	  <PageSEO section="legal" keyName="politica-cookies" />
	  
	  <main className="legal-page">
		<div className="container">
		  <Spacing size={6} />
		  
		  <div className="legal-content">
			<h1>POLITICA DE COOKIES</h1>
			<p className="last-updated"><strong>Data ultimei actualizări: {new Date().toLocaleDateString('ro-RO')}</strong></p>

			<section>
			  <h2>3.1 Ce sunt cookie-urile și tehnologiile similare</h2>
			  <p>Cookie-urile sunt fișiere mici de text stocate pe dispozitivul dumneavoastră când vizitați un site web. Pe lângă cookie-uri, folosim și alte tehnologii de tracking cum ar fi pixel-urile, care ne ajută să înțelegem comportamentul utilizatorilor și să optimizăm experiența.</p>
			</section>

			<section>
			  <h2>3.2 Platformele noastre</h2>
			  <p>Această politică se aplică pentru:</p>
			  <ul>
				<li><strong>pixado.ro</strong> - Site-ul principal (folosește doar cookie-uri esențiale și tracking)</li>
				<li><strong>ccshop.pixado.ro</strong> - Platforma DEMO pentru demonstrarea capabilităților e-commerce (folosește localStorage pentru simularea funcționalităților)</li>
			  </ul>
			</section>

			<section>
			  <h2>3.3 Cookie-urile pe pixado.ro (site principal)</h2>
			  
			  <div className="cookie-category">
				<h3>Cookie-uri tehnice (strict necesare)</h3>
				<div className="cookie-details">
				  <p><strong>Durata:</strong> Sesiune</p>
				  <p><strong>Scop:</strong> Funcționarea corectă a site-ului, securitate, sesiune utilizator</p>
				  <p><strong>Temeiul legal:</strong> Interesul legitim</p>
				  <p><strong>Nu pot fi dezactivate</strong> fără a afecta funcționarea site-ului</p>
				</div>
			  </div>

			  <div className="cookie-category">
				<h3>Google Analytics 4</h3>
				<div className="cookie-details">
				  <p><strong>Cookie-uri:</strong> _ga, _ga_*, _gid</p>
				  <p><strong>Durata:</strong> 2 ani / 24 ore</p>
				  <p><strong>Scop:</strong> Analiză trafic, comportament utilizatori, optimizare site</p>
				  <p><strong>Temeiul legal:</strong> Consimțământ</p>
				  <p><strong>Transfer internațional:</strong> Google LLC (SUA)</p>
				</div>
			  </div>

			  <div className="cookie-category">
				<h3>Facebook Pixel</h3>
				<div className="cookie-details">
				  <p><strong>Cookie-uri:</strong> _fbp, fr</p>
				  <p><strong>Durata:</strong> 3 luni / 90 zile</p>
				  <p><strong>Scop:</strong> Retargeting, măsurarea eficacității reclamelor Facebook</p>
				  <p><strong>Temeiul legal:</strong> Consimțământ</p>
				  <p><strong>Transfer internațional:</strong> Meta Platforms (SUA)</p>
				</div>
			  </div>

			  <div className="cookie-category">
				<h3>TikTok Pixel</h3>
				<div className="cookie-details">
				  <p><strong>Cookie-uri:</strong> _ttp, _tt_enable_cookie</p>
				  <p><strong>Durata:</strong> 13 luni</p>
				  <p><strong>Scop:</strong> Retargeting, măsurarea eficacității reclamelor TikTok</p>
				  <p><strong>Temeiul legal:</strong> Consimțământ</p>
				  <p><strong>Transfer internațional:</strong> TikTok Pte. Ltd. (Singapore)</p>
				</div>
			  </div>
			</section>

			<section>
			  <h2>3.4 Cookie-urile pe ccshop.pixado.ro (platforma DEMO)</h2>
			  
			  <div className="cookie-category">
				<h3>Cookie-uri tehnice și localStorage (pentru demonstrare)</h3>
				<div className="cookie-details">
				  <p><strong>Tehnologii:</strong> Cookie-uri de sesiune + localStorage</p>
				  <p><strong>Durata:</strong> Sesiune / Până la ștergerea browserului</p>
				  <p><strong>Scop:</strong> Simularea coșului de cumpărături, testarea funcționalităților demo</p>
				  <p><strong>Temeiul legal:</strong> Interesul legitim</p>
				  <p><strong>Date stocate:</strong> Produse fictive în coș, preferințe de test, navigare demo</p>
				  <p><strong>Important:</strong> Datele sunt fictive - nu se efectuează tranzacții reale!</p>
				</div>
			  </div>

			  <div className="cookie-category">
				<h3>Cookie-uri de simulare (DEMO)</h3>
				<div className="cookie-details">
				  <p><strong>Cookie-uri:</strong> demo_session, test_user_prefs</p>
				  <p><strong>Durata:</strong> Sesiune</p>
				  <p><strong>Scop:</strong> Simularea experienței de utilizator pentru demonstrare</p>
				  <p><strong>Temeiul legal:</strong> Interesul legitim</p>
				  <p><strong>Note:</strong> Nu există conturi reale sau date personale stocate</p>
				</div>
			  </div>

			  <p><strong>Plus toate cookie-urile de tracking de la pixado.ro</strong> (Google Analytics 4, Facebook Pixel, TikTok Pixel)</p>
			</section>

			<section>
			  <h2>3.5 Gestionarea consimțământului</h2>
			  
			  <div className="data-category">
				<h3>Cum să gestionați cookie-urile:</h3>
				<ul>
				  <li><strong>Panoul de consimțământ:</strong> Apare la prima vizită pe ambele site-uri</li>
				  <li><strong>Setările browserului:</strong> Pentru blocarea completă a cookie-urilor</li>
				  <li><strong>Opt-out direct:</strong> Link-uri către furnizorii de servicii</li>
				  <li><strong>localStorage (ccshop.pixado.ro):</strong> Se șterge prin setările browserului</li>
				</ul>
			  </div>

			  <div className="cookie-category">
				<h3>Opțiuni disponibile:</h3>
				<ul>
				  <li><strong>Acceptare completă:</strong> Toate cookie-urile și funcționalitățile</li>
				  <li><strong>Doar necesare:</strong> Cookie-uri tehnice + localStorage pentru funcționalitate</li>
				  <li><strong>Personalizat:</strong> Selectarea individuală pentru fiecare categorie</li>
				</ul>
			  </div>
			</section>

			<section>
			  <h2>3.6 Instrucțiuni pentru browsere populare</h2>
			  <div className="browser-instructions">
				<div className="browser-item">
				  <h4>Chrome</h4>
				  <p>Settings {`>`} Privacy and security {`>`} Cookies and other site data</p>
				  <p><strong>localStorage:</strong> Settings {`>`} Privacy {`>`} Clear browsing data</p>
				</div>
				<div className="browser-item">
				  <h4>Firefox</h4>
				  <p>Settings {`>`} Privacy & Security {`>`} Cookies and Site Data</p>
				  <p><strong>localStorage:</strong> Developer Tools {`>`} Storage tab</p>
				</div>
				<div className="browser-item">
				  <h4>Safari</h4>
				  <p>Preferences {`>`} Privacy {`>`} Manage Website Data</p>
				  <p><strong>localStorage:</strong> Develop {`>`} Web Inspector {`>`} Storage</p>
				</div>
				<div className="browser-item">
				  <h4>Edge</h4>
				  <p>Settings {`>`} Cookies and site permissions {`>`} Manage and delete cookies</p>
				  <p><strong>localStorage:</strong> F12 {`>`} Application {`>`} Local Storage</p>
				</div>
			  </div>
			</section>

			<section>
			  <h2>3.7 Consecințele respingerii cookie-urilor</h2>
			  
			  <div className="data-category">
				<h3>Pe pixado.ro:</h3>
				<ul>
				  <li><strong>Cookie-uri necesare:</strong> Nu pot fi dezactivate - site-ul nu va funcționa</li>
				  <li><strong>Google Analytics:</strong> Nu afectează funcționarea, dar pierdem date de optimizare</li>
				  <li><strong>Pixel-uri de marketing:</strong> Reclame mai puțin relevante pe alte platforme</li>
				</ul>
			  </div>

			  <div className="data-category">
				<h3>Pe ccshop.pixado.ro (platforma DEMO):</h3>
				<ul>
				  <li><strong>Cookie-uri + localStorage necesare:</strong> Demo-ul nu va funcționa corect, coșul de teste se va goli</li>
				  <li><strong>Cookie-uri de simulare:</strong> Experiența demo va fi limitată, nu se vor salva preferințele de test</li>
				  <li><strong>Cookie-uri de tracking:</strong> Aceleași consecințe ca pe site-ul principal</li>
				  <li><strong>Important:</strong> Nu afectează funcții reale de cumpărături pentru că nu există!</li>
				</ul>
			  </div>
			</section>

			<section>
			  <h2>3.8 Transferuri internaționale de date</h2>
			  <p>Cookie-urile de tracking transferă date către:</p>
			  <ul>
				<li><strong>Google (SUA):</strong> Protecție prin Adequacy Decision și Google Analytics Data Processing Terms</li>
				<li><strong>Meta/Facebook (SUA):</strong> Protecție prin Standard Contractual Clauses</li>
				<li><strong>TikTok (Singapore/SUA):</strong> Protecție prin măsuri de securitate adecvate și contracte de prelucrare</li>
			  </ul>
			</section>

			<section>
			  <h2>3.9 Actualizări ale politicii</h2>
			  <p>Această politică poate fi actualizată pentru a reflecta:</p>
			  <ul>
				<li>Schimbări în tehnologiile folosite</li>
				<li>Noi funcționalități pe platformele noastre</li>
				<li>Modificări în legislația privind protecția datelor</li>
				<li>Actualizări ale serviciilor terților (Google, Meta, TikTok)</li>
			  </ul>
			  <p>Verificați periodic această pagină pentru actualizări.</p>
			</section>

			<section>
			  <h2>3.10 Contact și întrebări</h2>
			  <p>Pentru întrebări despre utilizarea cookie-urilor sau pentru exercitarea drepturilor:</p>
			  <div className="contact-info">
				<p><strong>Email:</strong> <a href="mailto:contact@pixado.ro">contact@pixado.ro</a></p>
				<p><strong>Telefon:</strong> <a href="tel:+40745371620">+40 745 371 620</a></p>
				<p><strong>Operator de date:</strong> ITastic.ro SRL (brand Pixado)</p>
			  </div>
			</section>

			<section className="opt-out-links">
			  <h2>Link-uri utile pentru gestionarea cookie-urilor</h2>
			  
			  <div className="data-category">
				<h3>Opt-out servicii de tracking:</h3>
				<ul>
				  <li><a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer">Google Analytics Opt-out Browser Add-on</a></li>
				  <li><a href="https://www.facebook.com/help/568137493302217" target="_blank" rel="noopener noreferrer">Facebook - Despre reclamele bazate pe interese</a></li>
				  <li><a href="https://ads.tiktok.com/help/article/personalized-ads-and-data" target="_blank" rel="noopener noreferrer">TikTok - Personalized Ads Settings</a></li>
				</ul>
			  </div>

			  <div className="data-category">
				<h3>Ghiduri pentru browsere:</h3>
				<ul>
				  <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer">Chrome - Gestionarea cookie-urilor</a></li>
				  <li><a href="https://support.mozilla.org/en-US/kb/enhanced-tracking-protection-firefox-desktop" target="_blank" rel="noopener noreferrer">Firefox - Cookie Settings</a></li>
				  <li><a href="https://support.apple.com/en-us/HT201265" target="_blank" rel="noopener noreferrer">Safari - Cookie Management</a></li>
				  <li><a href="https://support.microsoft.com/en-us/windows/delete-and-manage-cookies-168dab11-0753-043d-7c16-ede5947fc64d" target="_blank" rel="noopener noreferrer">Edge - Cookie Management</a></li>
				</ul>
			  </div>
			</section>
		  </div>
		  
		  <Spacing size={6} />
		</div>
	  </main>
	</>
  );
};

export default PoliticaCookies;